var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPickupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.36469 0 0 3.21797 0 7.17188C0 9.05484 0.858281 11.5589 2.55094 14.6147C3.91031 17.0681 5.48297 19.2867 6.30094 20.3906C6.43916 20.5792 6.61987 20.7326 6.82844 20.8384C7.03701 20.9441 7.26757 20.9992 7.50141 20.9992C7.73525 20.9992 7.9658 20.9441 8.17437 20.8384C8.38294 20.7326 8.56366 20.5792 8.70188 20.3906C9.51844 19.2867 11.0925 17.0681 12.4519 14.6147C14.1417 11.5598 15 9.05578 15 7.17188C15 3.21797 11.6353 0 7.5 0ZM7.5 10.5C6.90666 10.5 6.32664 10.3241 5.83329 9.99441C5.33994 9.66476 4.95542 9.19623 4.72836 8.64805C4.5013 8.09987 4.44189 7.49667 4.55764 6.91473C4.6734 6.33279 4.95912 5.79824 5.37868 5.37868C5.79824 4.95912 6.33279 4.6734 6.91473 4.55764C7.49667 4.44189 8.09987 4.5013 8.64805 4.72836C9.19623 4.95542 9.66476 5.33994 9.99441 5.83329C10.3241 6.32664 10.5 6.90666 10.5 7.5C10.4991 8.29538 10.1828 9.05794 9.62036 9.62036C9.05794 10.1828 8.29538 10.4991 7.5 10.5Z",
    fill: "#9A999D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupIcon);
export default __webpack_public_path__ + "static/media/pickup_icon.3b65ddd84e9e5228b11efe8c7af5678d.svg";
export { ForwardRef as ReactComponent };